const PREFIX = "dvtrack"

export default {
  has(key) {
    return localStorage.hasOwnProperty(`${PREFIX}:${key}`)
  },

  get(key) {
    var value = localStorage.getItem(`${PREFIX}:${key}`)
    if (value) {
      return JSON.parse(value)
    }
  },

  fetch(key, fallback) {
    var value = localStorage.getItem(`${PREFIX}:${key}`)
    return value ? JSON.parse(value) : fallback
  },

  set(key, value) {
    localStorage.setItem(`${PREFIX}:${key}`, JSON.stringify(value))
    return value
  },

  remove(key) {
    localStorage.removeItem(`${PREFIX}:${key}`)
  },

  clear() {
    for (var i = 0; i < localStorage.length; i++) {
      var key = localStorage.key(i)
      if (key.startsWith(PREFIX)) {
        localStorage.removeItem(key)
      }
    }
  },
}
